import React, { useEffect, useRef } from 'react'
import { Provider, useSelector } from 'react-redux'
import Content from './components/content'
import LrSearch from './components/lrSearch'
import Header from './components/header/header'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import LoaderScreen from './components/common/loader'
import GstInvoice from './components/gstInvoice'
import TicketPreview from './components/previews'
import { useAtom } from 'jotai'
import { globalLoaderAtom } from './components/common/jotaiState/globalStateAtoms'
import ViewReport from './components/common/ViewReport'
import ViewReportV2 from './components/common/ViewReportV2'

function App({ store }) {
  const loader = useSelector((state) => state.common.loader)
  const [loaderJotai] = useAtom(globalLoaderAtom)
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route
            exact
            path="/commonlr"
            element={
              <>
                {(loader || loaderJotai) && <LoaderScreen />}
                <LrSearch store={store} />
              </>
            }
          />
          <Route exact path="/GSTInvoice" element={<GstInvoice store={store} />} />
          <Route exact path="/preview" element={<TicketPreview store={store} />} />
          <Route exact path="/view-report" element={<ViewReport />} />
          <Route exact path="/view-reportV2" element={<ViewReportV2 />} />
          <Route
            exact
            path="/"
            element={
              <>
                {(loader || loaderJotai) && <LoaderScreen />}
                <Header store={store} />
                <Content store={store} />
              </>
            }
          />
          <Route
            path="*"
            element={
              <>
                {loader && <LoaderScreen />}
                <Header store={store} />
                <Content store={store} />
              </>
            }
          />
        </Routes>
      </Router>
    </Provider>
  )
}

export default App
